module.exports = {
  "Fintech_Payment_modification_JNDB_IyfS": "Upload Again",
  "Fintech_Payment_information_igvK_UYAz": "You can add beneficiaries here, and set allocation ratios for them",
  "Fintech_Payment_deposit_sXgz_qKip": "Verify the details and enter the amount you want to deposit into {{DiDi_Cuenta}}.",
  "Fintech_Payment_modification_MBsk_LuPn": "Upload Again Now?",
  "Fintech_Payment_KYC_gnTH_YXOJ": "City / Region",
  "Fintech_Payment_KYC_ACoB_YJFy": "Invalid verification code. Please try again",
  "Fintech_Payment_KYC_SpcY_yEkL": "Block (Optional)",
  "Fintech_Payment_AF_iYUV_RZqQ": "Payee",
  "Fintech_Payment_OTP_pEfV_rJQv": "I don’t have WhatsApp",
  "Fintech_Payment_information_gLTw_udZk": "Beneficiary’s Name",
  "Fintech_Payment_Bankstatement_VJGG_mzkf": "Transaction Activity Details",
  "Fintech_Payment_Bankstatement_BQiZ_jAEw": "Index of Abbreviations",
  "Fintech_Payment_website_ojec_kGmp": "Please Enter Your Info",
  "Fintech_Payment_out_EwYp_MJFT": "Enter CLABE",
  "Fintech_Payment_out_DUKE_nxdr": "Add an Alias",
  "Fintech_Payment_out_dMcV_dFtS": "Receiving Bank",
  "Fintech_Payment_information_DIYt_yZyx": "Mobile Number",
  "Fintech_Payment_modification_plkZ_lsUh": "Use of CFDI",
  "Fintech_Payment_website_vyuH_wVPZ": "Only Spanish letters, spaces and hyphens (-) can be entered",
  "Fintech_Payment_out_RDFl_sSQx": "CLABE copied",
  "Fintech_Payment_KYC_dKAT_heay": "CURP and gender don’t match. Please check the entered information",
  "Fintech_Payment_Bankstatement_SGNJ_vMFp": "Address: {{Sofipo_address}}",
  "Fintech_Payment_KYC_eGso_jeAS": "Confirm",
  "Fintech_Payment_website_uwvO_Tgil": "Please enter a valid email address format",
  "Fintech_Payment_AF_EsIM_hGCv": "May",
  "Fintech_Payment_KYC_hVEQ_wtLy": "Address cannot exceed 200 characters",
  "Fintech_Payment_Optimization_NOin_alml": "Refreshed successfully",
  "Fintech_Payment_KYC_gWXw_nbwh": "Verification successful",
  "Fintech_Payment_Bankstatement_UMxV_lSvi": "{{JP_Sofiexpress}} has a dedicated Customer Support department located at {{Sofipo_UNE_address}}. You can contact the department via email at {{Sofipo_UNE_email}}, by phone at {{Sofipo_UNE_telephone_number}} or by visiting any of its branches or offices for inquiries, claims, or clarifications. If you are not satisfied with the response, you may contact the National Commission for the Protection and Defense of Users of Financial Services (CONDUSEF) ({{condusef_URL}}, {{condusef_telephone_number1}}, {{condusef_telephone_number2}}) for help.",
  "Fintech_Payment_2_pXvO_pqxr": "Only numbers allowed",
  "Fintech_Payment_Optimization_tyId_PGmu": "Expenses",
  "Fintech_Payment_deposit_epmY_qubZ": "Deposit via SPEI",
  "Fintech_Payment_AF_VBip_Mdss": "Session expired. Please sign in again",
  "Fintech_Payment_AF_MXod_mPID": "Balance",
  "Fintech_Payment_out_qfne_lRTR": "Transfer to CLABE",
  "Fintech_Payment_limits_jyYN_OrOp": "Supervised by CNBV",
  "Fintech_Payment_information_JlDn_qwie": "Beneficiary {{successor_id}}",
  "Fintech_Payment_Bankstatement_rIXn_CUsc": "Payer",
  "Fintech_Payment_page_OQck_lyCE": "I’m Still Interested",
  "Fintech_Payment_limits_daNT_fZSS": "Please try again later",
  "Fintech_Payment_Bankstatement_caBV_jSuG": "Name: {{client_name}}",
  "Fintech_Payment_2_GErt_OBdg": "Please enter a 10-digit mobile number",
  "Fintech_Payment_website_bEUT_jSda": "You’re waitlisted! We’ll contact you by SMS/email when you can use {{brand_name}}.",
  "Fintech_Payment_information_ZlKa_dtuo": "Are you sure you want to delete this beneficiary?",
  "Fintech_Payment_information_bUKL_JKrn": "State, Country",
  "Fintech_Payment_AF_HEgl_AkAn": "Jun",
  "Fintech_Payment_Bankstatement_cklR_SqlI": "You are viewing your bank statement. Reports are generated automatically on a monthly basis and cover transactions for up to 12 months. To download a report exceeding the 12-month period, please contact Customer Support. The latest report date is {{last_time}}.",
  "Fintech_Payment_Bankstatement_fSIt_lCnP": "Select Period",
  "Fintech_Payment_display__aCTQ": "Loading...",
  "Fintech_Payment_limits_jOLq_KpIA": "The amount you entered exceeds the maximum limit. Please adjust it.",
  "Fintech_Payment_AF_gnPZ_eMwX": "Last signed in: {{last_login_time}}",
  "Fintech_Payment_limits_laEJ_ZcnK": "Failed to Load",
  "Fintech_Payment_website_FUOx_KRLc": "This service is provided by {{Company_name}}",
  "Fintech_Payment_limits_PTcx_pRPt": "The amount you entered must be an integer.",
  "Fintech_Payment_AF_FSRh_XVKV": "Top up and use your {{brand_name}} account now",
  "Fintech_Payment_out_jXPS_kJIE": "Payee copied",
  "Fintech_Payment_information_zyZu_choS": "{{beneficiary_percent}} left to allocate",
  "Fintech_Payment_Bankstatement_Vsvj_rvxs": "Deposit",
  "Fintech_Payment_KYC_TVHz_LQmK": "Female",
  "Fintech_Payment_deposit_CRGm_UzpX": "Copy and share this information to make a deposit to {{DiDi_Cuenta}}",
  "Fintech_Payment_Bankstatement_kAPb_djfK": "Date",
  "Fintech_Payment_website_JrDT_oghx": "2 minutes",
  "Fintech_Payment_information_LxSZ_QfdR": "Interior Apartment No. (Optional)",
  "Fintech_Payment_Bankstatement_UDGs_sWUv": "Description",
  "Fintech_Payment_modification_XLGP_PkVO": "Failed to preview file",
  "Fintech_Payment_Bankstatement_vcou_ppHK": "Download",
  "Fintech_Payment_out_JVhf_uIrz": "It usually takes {30 seconds} for funds to be added to your Balance. If funds are not received within {1 hour}, please contact us",
  "Fintech_Payment_modification_WpyW_UDnG": "Once you choose to upload again, the latest fiscal information may change.",
  "Fintech_Payment_deposit_hPpV_qxBY": "Confirm Information",
  "Fintech_Payment_out_xxZL_QggI": "Up to {{amount}} can be transferred this time",
  "Fintech_Payment_Optimization_EtqY_nFMb": "The current returns do not meet the tax threshold, so no tax applies",
  "Fintech_Payment_KYC_UCNu_RKcO": "Zip Code",
  "Fintech_Payment_KYC_Lwxq_yulz": "Invalid email address format",
  "Fintech_Payment_page_ZyPv_vdFF": "Invite via QR Code",
  "Fintech_Payment_deposit_wGvf_isDi": "Enter Your CLABE",
  "Fintech_Payment_information_SgIA_tmLD": "Beneficiary updated successfully",
  "Fintech_Payment_compliance_cKLo_wJIN": "Amount exceeds {{amount_limit}}. Please save your payee first",
  "Fintech_Payment_modification_zGjh_jAAr": "Verifying Your Document",
  "Fintech_Payment_KYC_Oilm_lUbJ": "Poor network connection. Please try again later",
  "Fintech_Payment_Bankstatement_bjpO_mnaj": "Since {{JP_Sofiexpress}} does not charge users any service fees or other fees, your minimum required balance is 0.",
  "GDriver_MX_No_more_bWUF": "No more data available",
  "Fintech_Payment_page_XQQd_oNyh": "No invitations yet",
  "Fintech_Payment_modification_AByR_jggK": "Not Now",
  "Fintech_Payment_homepage_aMFD_pFAF": "You’ve enabled your {{brand_name}} Balance, so {{DiDi}} Balance top-up services are no longer available. We hope you enjoy an improved payment experience with your {{brand_name}} Balance. Thank you for your understanding and support.",
  "Fintech_Payment_Bankstatement_PYtp_iPQw": "Beginning Balance",
  "Fintech_Payment_out_XYAo_yuwB": "CLABE",
  "Fintech_Payment_AF_kABS_zWvf": "Sep",
  "Fintech_Payment_Bankstatement_AzQw_luej": "Email: {{Sofipo_email}}",
  "Fintech_Payment_page_ocIy_NGRn": "Please enter a valid mobile number",
  "Fintech_Payment_KYC_OnLo_ZYch": "Enter Your Personal Details",
  "Fintech_Payment_homepage_SFsi_SJXU": "Please Use Your {{brand_name}} Balance",
  "Fintech_Payment_KYC_zTko_YFzn": "This CURP is already in use",
  "Fintech_Payment_out_amMV_dDSd": "CLABE",
  "Fintech_Payment_AF_fOga_XwyT": "Unable to verify. Please try again",
  "Fintech_Payment_AF_nmDo_eTLN": "Jan",
  "Fintech_Payment_Bankstatement_hnLc_DSHR": "Withdrawal",
  "Fintech_Payment_simulado_QWNv_ULIU": "Deposit Amount ({{monetary_unit}})",
  "Fintech_Payment_KYC_Xwxu_tMgl": "Please enter this information",
  "Fintech_Payment_information_msbx_XiQZ": "What is an account ID?",
  "Fintech_Payment_deposit_Mlzl_OiyY": "Recipient",
  "Fintech_Payment_Cap_oZyP_BVoJ": "Calculation Rules",
  "Fintech_Payment_interest_VgrE_mFyX": "Total",
  "Fintech_Payment_M2_Network_error_pnLW": "Network error. Please try again",
  "Fintech_Payment_deposit_VPvi_NjxF": "Destination Bank",
  "Fintech_Payment_AF_qJnT_LvYT": "View All",
  "Fintech_Payment_Bankstatement_cqQj_yfpk": "Top Up Service Fee",
  "Fintech_Payment_AF_qSLd_ePln": "Transaction Type",
  "Fintech_Payment_KYC_OZAY_SMnC": "Invalid name format. Please try again",
  "Fintech_Payment_limits_ytGb_sMaw": "The amount you entered is outside the allowed range. Please revise it.",
  "Fintech_Payment_KYC_vZch_DBhR": "Enter SMS Verification Code",
  "Fintech_Payment_AF_odav_vTWX": "Dec",
  "Fintech_Payment_information_zqzM_ASyc": "Keep",
  "Fintech_Payment_Ahorro_FTbq_RnIh": "Please try again later",
  "Fintech_Payment_out_eDqd_heBu": "Verified Name",
  "Fintech_Payment_Bankstatement_BWgn_zVrT": "Withdrawals",
  "Fintech_Payment_KYC_Nrcd_vCpz": "Verification Code Expired",
  "Fintech_Payment_Optimization_DsID_ESxl": "Refreshing",
  "Fintech_Payment_AF_Trse_OFqS": "Hi, {{user_name}}",
  "Fintech_Payment_website_hsGy_KTiW": "Submit",
  "Global_Rider_1219_Global_Rider_Adding_Card_Components_Optimization_Try_again_gvWg": "Try Again",
  "Fintech_Payment_page_lcMk_kyGN": "Share on WhatsApp",
  "Fintech_Payment_KYC_UfeV_RamV": "CURP and date of birth don’t match. Please check the entered information",
  "Fintech_Payment_KYC_hava_mqZj": "Male",
  "Fintech_Payment_Bankstatement_ewnH_wIGD": "Inquiries and Complaints",
  "Fintech_Payment_information_tLUn_cjbv": "Not Now",
  "Fintech_Payment_information_pHvH_OrLr": "As required by law, in case of an accident, the funds in your account will be allocated to your beneficiaries according to your specified allocation ratios. Please set the ratios carefully.",
  "Fintech_Payment_information_opfz_BtoE": "Zip Code",
  "Fintech_Payment_information_EixC_MnqL": "Account ID",
  "Fintech_Payment_modification_ewfK_RdNL": "My Tax Information",
  "Fintech_Payment_AF_BCXN_zpQI": "All",
  "Fintech_Payment_out_nRbM_mVvJ": "System is busy. Please try again ({{cs_code}})",
  "Fintech_Payment_KYC_XwnO_pauL": "Invalid zip code. Please check",
  "Fintech_Payment_Bankstatement_dqvf_vpkB": "Action",
  "Fleet_Resdesign_Data_loading_pcxE": "Loading data...",
  "Fintech_Payment_KYC_xqow_swLI": "Skip",
  "Fintech_Payment_Bankstatement_Seea_rKSe": "Phone Number: {{Sofipo_telephone_number}}",
  "Fintech_Payment_website_YdzR_rNSY": "4 steps",
  "Fintech_Payment_modification_JYgu_ThhR": "System version too low. Access to the file is denied",
  "Fintech_Payment_KYC_KfPp_SnbQ": "For any questions, please contact Customer Support: {{sofipo_csphone}}",
  "Fintech_Payment_Bankstatement_RisF_kGmY": "Important Notice",
  "Fintech_Payment_KYC_wsSR_nQPv": "Continue",
  "Fintech_Payment_out_prmp_xxVR": "Payee",
  "Fintech_Payment_KYC_MKmB_EkXV": "Name",
  "Fintech_Payment_page_JPfV_zUWX": "Oops! Something went wrong",
  "Fintech_Payment_page_IYZc_JGJx": "Please try again later or check your network connection. If the issue persists, try using a different network.",
  "Fintech_Payment_page_IICG_TMSY": "Invite via System Share",
  "Fintech_Payment_information_Wjkj_hnPe": "Street",
  "Fintech_Payment_AF_uUvN_EGHm": "Transfer",
  "Fintech_Payment_page_CTsY_Dmrb": "Got It",
  "Fintech_Payment_Bankstatement_wIxX_zPcR": "SPEI Deposit",
  "Fintech_Payment_limits_NaMf_JcsO": "Refresh",
  "Fintech_Payment_Ahorro_dGgq_KZal": "Try Again",
  "Fintech_Payment_KYC_ENgG_RwQm": "Enter Second Surname",
  "Fintech_Payment_KYC_cBre_kkHZ": "You have one attempt left in the next {{occupied_retry_limit_hour}} hour(s). If the attempt is unsuccessful, you can try again after {{occupied_retry_limit_hour}} hour(s)",
  "Fintech_Payment_page_sVWx_pnmL": "Update to the latest version to join this event, or tap to explore more events from {{didi_cuenta}}.",
  "Fintech_Payment_out_MSnG_HwNe": "Recent",
  "Fintech_Payment_out_GPAk_BVgb": "Payees",
  "Fintech_Payment_out_xqdz_fptx": "Receiving Bank",
  "Fintech_Payment_helpcenter_kDlf_knuA": "{{brand_name}} Help Center",
  "Fintech_Payment_Bankstatement_NBuR_UWJy": "Payee",
  "Fintech_Payment_Bankstatement_gHRD_NonM": "Daily Average Balance",
  "Fintech_Payment_AF_iGoO_ypBi": "History",
  "Fintech_Payment_modification_MdCM_dIqR": "Invalid file format",
  "Fintech_Payment_out_KRxS_XwKV": "Next",
  "Fintech_Payment_AF_HwIo_FrYZ": "Transaction Details",
  "Fintech_Payment_compliance_Wyil_Zaqm": "Save Payee",
  "Fintech_Payment_compliance_kmji_yDPA": "Save your payee to make things easier next time.",
  "Fintech_Payment_ABtest_DgLn_aapk": "Generating CLABE. Once completed, we will notify you via email and SMS",
  "Fintech_Payment_modification_krBM_IhkQ": "Tax Regime",
  "Fintech_Payment_information_SqPO_GduE": "My Profile",
  "Fintech_Payment_2_SslK_PSat": "Please enter a mobile number with the correct number of digits",
  "Fintech_Payment_Optimization_tHGy_IYgN": "Release to refresh",
  "Fintech_Payment_information_gien_BDnw": "Beneficiary must be 18 to 85 years old",
  "Fintech_Payment_information_gzjP_DzDg": "Beneficiary’s Second Surname",
  "Fintech_Payment_ABtest_nNTe_vZMb": "Unable to copy. Please try again",
  "Fintech_Payment_limits_fmtm_NrdR": "OK",
  "Fintech_Payment_page_oDTv_Emyj": "I’ll Pass",
  "Fintech_Payment_Bankstatement_UpAF_OORe": "If you have any questions regarding transactions or other information, please contact our Customer Support at {{CS_phone_number}}. You have up to 90 days to request any clarifications.",
  "Fintech_Payment_interest_BAfU_KYJw": "Returns",
  "Fintech_Payment_information_cBgX_dXkO": "Exterior Apartment No.",
  "Fintech_Payment_out_sDmk_VATG": "(Optional)",
  "Fintech_Payment_information_rYgt_cISP": "Ratio cannot be less than 1%",
  "Fintech_Payment_interest_kGNQ_pVHx": "Tax deducted",
  "Fintech_Payment_AF_QpIB_AERj": "Feb",
  "Fintech_Payment_information_FDpV_ODgJ": "Beneficiary’s First Surname",
  "Fintech_Payment_website_mavi_GbHP": "Enter email address",
  "Fintech_Payment_out_YhXy_rMmr": "Top up {{brand_name}} balance using the following information",
  "Fintech_Payment_Bankstatement_jnum_icwT": "Transaction ID",
  "Fintech_Payment_Optimization_bymF_byCA": "Transaction Result",
  "Fintech_Payment_Homepage_lqUj_UKQg": "Deposit",
  "Fintech_Payment_deposit_qpup_NGOx": "CLABE",
  "Fintech_Payment_limits_EZti_bVFY": "The amount you entered cannot be 0.",
  "Fintech_Payment_KYC_DtGd_zTDS": "Email",
  "Fintech_Payment_website_LWta_xkpm": "Submitted successfully",
  "Fintech_Payment_information_AfvT_aEBB": "Neighborhood",
  "Fintech_Payment_Bankstatement_hOdy_FqBn": "Balance",
  "Fintech_Payment_page_xOpT_iwcr": "Are you really going to miss the chance to invite your friends to join {{DiDi_Cuenta}}? You can help them earn more!",
  "Fintech_Payment_Bankstatement_kxBr_CoBu": "System error",
  "Fintech_Payment_website_PQAp_tKWp": "Look forward to seeing you!",
  "Fintech_Payment_interest_kSNl_nSdf": "Returns Estimator",
  "Fintech_Payment_AF_rfVr_WNwz": "Aug",
  "Fintech_Payment_ABtest_TuaL_SrVk": "Copied successfully",
  "Fintech_Payment_modification_eWBN_NQGs": "Once the verification is complete, we will notify you of the result via email.",
  "Fintech_Payment_KYC_fIJh_dXsj": "Gender",
  "Fintech_Payment_interest_bjTF_glLz": "Amount after deducting tax",
  "Fintech_Payment_deposit_knBn_gUEK": "Your funds are protected by the protection fund.",
  "Fintech_Payment_AF_fXUE_ZcYk": "History",
  "Fintech_Payment_KYC_TYRL_UHBj": "Invalid phone number",
  "Fintech_Payment_deposit_MUBS_fNDh": "Destination Bank",
  "Fintech_Payment_modification_Gyta_xHeT": "File too large (exceeds maximum limit)",
  "Fintech_Payment_information_gvGr_wpac": "There is no proportion to allocate to new beneficiaries. To add another beneficiary, please adjust your allocations first",
  "Fintech_Payment_modification_itwI_hUTZ": "Failed to read file",
  "Fintech_Payment_modification_RSHt_ndfh": "Second Surname",
  "Fintech_Payment_KYC_Qlzk_XvJj": "Oops! You have reached the limit of {{limit_times}} attempts in {{occupied_retry_limit_hour}} hours.",
  "Fintech_Payment_information_awgy_TfAc": "Municipality",
  "Fintech_Payment_deposit_CZPp_ckng": "CLABE",
  "Fintech_Payment_Optimization_BIAB_lwdr": "Transaction Details",
  "Fintech_Payment_limits_nTTb_OIBh": "Invalid amount. Please try again.",
  "Fintech_Payment_KYC_AnWj_fktR": "Enter Your Contact Information",
  "Fintech_Payment_loading_Qfvd_dMwV": "Authorization in progress",
  "Fintech_Payment_Bankstatement_cwrx_hynB": "Preview",
  "Fintech_Payment_deposit_tUEw_gdkO": "Your deposit is typically received within a few minutes to an hour, but in some cases, it may take up to 24 hours. You will be notified by email as soon as we receive the funds.",
  "Fintech_Payment_page_otEb_WJBX": "Give up the Chance to Help Your Friends Earn More?",
  "Fintech_Payment_out_gwMW_faQG": "Copy",
  "Fintech_Payment_yield_tFZR_WuHd": "Registration failed. Please try again",
  "Fintech_Payment_KYC_eWvY_kNRU": "Name cannot exceed 100 characters",
  "Fintech_Payment_Ahorro_mFQz_mpkb": "Poor Network Connection",
  "Fintech_Payment_out_vXtA_BWXM": "Save your {{brand_name}} CLABE and enter a top-up amount",
  "Fintech_Payment_AF_yLfN_dGSL": "Top Up",
  "Fintech_Payment_KYC_bfgH_PnwM": "Got It",
  "Fintech_Payment_Bankstatement_Aasp_ARbC": "First Surname: {{client_father_surname}}",
  "Fintech_Payment_deposit_pGCE_WTug": "Your funds are protected by the protection fund.",
  "Fintech_Payment_Bankstatement_FAXa_uhmr": "Transfer Service Fee",
  "Fintech_Payment_Bankstatement_HnlA_MYGF": "Address: {{client_address}}",
  "Fintech_Payment_AF_gZgm_wjTw": "Confirm",
  "Fintech_Payment_out_YguV_vhYc": "Done",
  "Fintech_Payment_out_JvbB_ULMX": "Bank Name",
  "Fintech_Payment_compliance_myyv_UNBP": "Saved successfully",
  "Fintech_Payment_Bankstatement_ylvG_Dywq": "Rate",
  "Fintech_Payment_AF_KMcq_mVba": "Jul",
  "Fintech_Payment_simulado_DiNq_bAix": "Duration (days)",
  "Fintech_Payment_page_vslk_brnN": "View My Invitations",
  "Fintech_Payment_page_WqZl_sRoM": "Show more",
  "Fintech_Payment_information_TrDL_iykt": "Stay Here",
  "Fintech_Payment_information_RBeT_ASwx": "Name",
  "Fintech_Payment_optimization_lSek_omte": "All",
  "Fintech_Payment_KYC_qrff_Jjlj": "Street/ave. and number (interior and exterior)",
  "Fintech_Payment_out_tpAm_Gebw": "The maximum transfer amount is {{amount}}, do not exceed it",
  "Fintech_Payment_KYC_YHhc_UqVg": "Please confirm you have entered your CURP correctly. For any questions, please contact Customer Support: {{sofipo_csphone}}",
  "Fintech_Payment_website_oDvN_dDjs": "We’ll notify you by SMS and email when you can use {{brand_name}} services",
  "Fintech_Payment_modification_AxYk_gqDO": "First Surname",
  "Fintech_Payment_KYC_AXpD_yHSr": "Please confirm you have entered your mobile number correctly. For any questions, please contact Customer Support: {{sofipo_csphone}}",
  "Fintech_Payment_Bankstatement_oURi_nwyv": "Payment",
  "Fintech_Payment_information_HyID_LHyK": "Add a Beneficiary",
  "Fintech_Payment_compliance_XDas_earR": "Network error. Please try again",
  "Fintech_Payment_page_DKvP_LGHp": "Try Again",
  "Fintech_Payment_Bankstatement_UsnV_GrXD": "Client ID: {{client_ID}}",
  "Fintech_Payment_AF_TplY_FLqG": "{{brand_name}} Balance",
  "Fintech_Payment_out_VHkP_Imvq": "Submit Transfer",
  "GRider_part2_Cancel_pNIR": "Cancel",
  "Fintech_Payment_KYC_VsBG_JucB": "Second Surname",
  "Fintech_Payment_Ahorro_DtZv_ntHp": "Unstable network connection. Please try again later",
  "Fintech_Payment_information_EmHe_dUby": "You can add up to {{beneficiary_max}} beneficiaries.",
  "Fintech_Payment_website_jKqP_Gqla": "By continuing, you agree with the {{Notice_name}}",
  "Fintech_Payment_KYC_qTby_Fnnc": "Invalid CURP format. Please try again",
  "Fintech_Credit_adjustment_TzfM_zgIR": "Sign Out",
  "Fintech_Payment_page_xxda_gEqM": "Download {{Dinero}}",
  "Fintech_Payment_AF_iknn_PlqT": "Sign In",
  "Fintech_Payment_KYC_qXAw_pVOQ": "Second surname is missing. Do you have a second surname?",
  "Fintech_Payment_KYC_ysqu_aYrF": "Accept and Sign the Agreement",
  "Fintech_Payment_page_eqrN_OTpK": "Enter mobile number",
  "Fintech_Payment_information_hgYQ_tQxl": "Email Address",
  "Fintech_Payment_information_TBSl_StvR": "Copy",
  "Fintech_Payment_Bankstatement_vlax_qixg": "Continued on Next Page",
  "Fintech_Payment_yield_zEwg_qbJg": "No past event records",
  "Fintech_Payment_AF_OEFN_ytYe": "Mar",
  "Fintech_Payment_Optimization_oOuc_Cfsk": "Income",
  "Fintech_Payment_Page_jeVI_qDzp": "Loading...",
  "Fintech_Payment_modification_eQwF_xWxX": "Network error. Please try again later",
  "Fintech_Payment_interest_urQk_fzCP": "Deposit amount",
  "Fintech_Payment_deposit_YUps_erzK": "Deposit Completed",
  "Fintech_Payment_information_DVNj_AgnB": "Save",
  "Fintech_Payment_out_yZsY_EvIm": "18-digit number",
  "Fintech_Payment_information_tTZZ_hLLV": "Set ratio here",
  "Fintech_Payment_modification_EGDg_LnPx": "RFC",
  "Fintech_Payment_Bankstatement_ODrW_rHOu": "Closing Balance",
  "Fintech_Payment_Bankstatement_ePTe_dXpF": "Account ID: {{account_ID}}",
  "Fintech_Payment_KYC_lbWE_gASK": "First Surname",
  "Fintech_Payment_Bankstatement_aPih_wMNV": "Deposits",
  "Fintech_Payment_2_mJns_qxor": "Download app",
  "Fintech_Payment_KYC_RgjA_vYVl": "Date of Birth",
  "Fintech_Payment_Bankstatement_jFfT_dnLZ": "Period: {{bank_statement_period}}",
  "Fintech_Payment_AF_pJXV_lZvb": "Apr",
  "Fintech_Credit_2_uFFp_xzbd": "Zip code",
  "Fintech_Payment_website_lqdT_FJGg": "Enter name",
  "Fintech_Payment_information_KUsQ_cYXy": "Copied",
  "Fintech_Payment_AF_WOJT_DqtE": "Deposit",
  "Fintech_Payment_out_UstT_nhmd": "Copy your {{brand_name}} {CLABE} to your bank app, or provide it to your bank",
  "Fintech_Payment_interest_xSFa_WJEH": "Duration (month)",
  "Fintech_Payment_KYC_hCgl_mGgu": "Verification code sent to {{user_phone}}",
  "Fintech_Payment_Bankstatement_JpFH_XKLj": "Bank Statement",
  "Fintech_Payment_information_pApu_zbLJ": "Exit",
  "Fintech_Payment_deposit_NBVB_Eeln": "Recipient",
  "Fintech_Payment_out_eONV_CHHd": "Saved Payees",
  "Fintech_Payment_information_ziNL_LQwo": "If you exit this page, the information you entered won’t be saved. Exit anyway?",
  "Fintech_Payment_compliance_VAAJ_cYfZ": "Unable to save. Please try again",
  "Fintech_Payment_information_sROF_duGS": "The Account ID is the unique identifier for your account. It can be used when contacting Customer Support to do things like check your account info and request statements",
  "Fintech_Payment_change_lUYQ_yEus": "Open an account in just 3 minutes",
  "Fintech_Payment_out_KmNP_EINS": "Please enter a valid 18-digit CLABE",
  "Fintech_Payment_Optimization_dMIL_yaHK": "Pull to refresh",
  "Fintech_Payment_Bankstatement_EluZ_PzvO": "Service Fee Details",
  "Fintech_Payment_homepage_oPWn_PLKR": "Got It",
  "Fintech_Payment_KYC_Wocg_BFmh": "Mobile Number (for verification code)",
  "Fintech_Payment_Bankstatement_WFuw_mHmR": "Bank statement verification failed",
  "Fintech_Payment_website_lwrz_wDUy": "Enter mobile number",
  "Fintech_Payment_KYC_xGBA_EheK": "Resend",
  "Fintech_Payment_KYC_MsXR_sJQR": "Place of Birth",
  "Fintech_Payment_Bankstatement_GvAh_icxd": "Days in Period: {{days_of_period}}",
  "Fintech_Payment_Optimization_OxQL_YjpS": "Total Amount",
  "Fintech_Payment_information_JKkT_xZkL": "Total ratio equals 100%",
  "Fintech_Payment_page_rBAg_wXlw": "Not Signed In",
  "Fintech_Payment_information_QXCX_lMaj": "Date of Birth",
  "Fintech_Payment_Bankstatement_eert_SSpI": "Amount",
  "Fintech_Payment_AF_BUgR_eCUa": "Nov",
  "Fintech_Payment_information_VbVV_XOSn": "Delete",
  "Fintech_Payment_information_ViRA_fPZX": "Set allocation ratios for the beneficiaries. The total of all ratios must be 100%.",
  "Fintech_Payment_website_eJnt_dWIz": "Opening a {{brand_name}} account takes just 2 mins and requires ID verification.",
  "Fintech_Payment_information_bqmo_InXV": "Beneficiary Info",
  "Fintech_Payment_deposit_fTwc_mSVi": "Open your banking app or website and find the transfer feature. Copy and paste the CLABE.",
  "Fintech_Payment_Bankstatement_ZjXW_HvDF": "Type",
  "Fintech_Payment_AF_kbUg_IwcT": "Hi, Welcome Back",
  "Fintech_Payment_Optimization_onZm_HWQv": "Got It",
  "Fintech_Payment_information_QZfY_vkgM": "Personal Info",
  "Fintech_Payment_modification_DmzX_NThI": "Here is your latest tax information. Please ensure it matches the SAT information. If not, you will need to upload it again.",
  "Fintech_Payment_2_WgYE_UdrG": "Risk verification failed",
  "Fintech_Payment_2_nhbq_BHft": "You can save the image and invite your friends to scan the QR code above to join the event.",
  "Fintech_Payment_page_VCEr_tmwW": "Choose a Way to Share",
  "Fintech_Payment_out_EOvE_qAwT": "Share Information",
  "Fintech_Payment_information_kxof_vUbv": "State",
  "Fintech_Payment_page_YKwh_MTEd": "New Version Available",
  "Fintech_Payment_information_kcbW_iRYZ": "Country",
  "Wallet_App_V2_Please_confirm_Pdiy": "Please check your network settings and try again later.",
  "Fintech_Payment_out_pxGY_wlQW": "Enter transfer amount",
  "Fintech_Payment_Bankstatement_nQyR_PjUQ": "Currency",
  "Fintech_Payment_out_mTCa_SdSS": "Transfer Amount",
  "Fintech_Payment_information_xbPB_LJNs": "Once saved, the information above will be legally enforceable. Save now?",
  "Fintech_Payment_KYC_xTXj_JDgc": "This mobile number is already in use",
  "Fintech_Payment_AF_HEfh_nZDt": "No transactions",
  "Fintech_Payment_modification_dczQ_FbPu": "Your fiscal information has been updated successfully",
  "Fintech_Payment_Bankstatement_PCJo_LTwh": "Withdrawal Service Fee",
  "Fintech_Payment_Bankstatement_qAyc_YplQ": "Unable to load data. Please try again later",
  "Fintech_Payment_KYC_Aufz_tEJN": "Got It",
  "Fintech_Payment_page_CsDR_GUBk": "Try Again",
  "Fintech_Payment_Optimization_SToL_eqvn": "Filter",
  "Fintech_Payment_modification_GLNo_TyMd": "Name",
  "Fintech_Payment_Bankstatement_QESf_XgpX": "Second Surname: {{client_mother_surname}}",
  "Fintech_Payment_Homepage_GLan_EOfn": "Your funds are protected by the Protection Fund",
  "Fintech_Payment_out_VYYS_orQb": "Payee’s Name",
  "Fintech_Payment_page_gsRP_Xfxf": "Remind",
  "Fintech_Payment_information_hHXE_gOtp": "Total of all ratios exceeds {{exceed_percent}}. Please adjust the allocations",
  "Fintech_Payment_Bankstatement_qwYv_fnps": "Transfer",
  "Fintech_Payment_KYC_BHGw_Oqap": "CURP",
  "Fintech_Payment_out_lghW_FUcU": "How to Top Up",
  "Fintech_Payment_AF_tkBP_jobH": "Oct",
  "Fintech_Payment_management_sRyk_czjm": "Loading...",
  "Fintech_Payment_Bankstatement_FiNb_nubW": "Page {{page_number}} of {{number_of_pages}}",
  "Fintech_Payment_out_QYBO_jRKW": "Notes",
  "Fintech_Payment_interest_BbNK_VACp": "Duration (months)",
  "Fintech_Payment_Bankstatement_tWjm_XCjp": "Total",
  "Fintech_Payment_Bankstatement_lSib_SWyR": "Bank statement transaction not found",
  "Fintech_Payment_website_zuqt_NNQR": "Please enter a 10-digit number",
  "Fintech_Payment_helpcenter_jjmJ_itJL": "Answer"
}